import { C } from "../../shared/theme";

// Three ways into a coaching chat: plan the day, get motivated, or check in. It sits in Today's Inspiration on
// Today (on Radar too from 23 to 25 Oct 2026), under its own label: the "Need Help Getting Started?" heading above it went
// on 24 Oct 2026 (Craig: "remove the 'Need Help Getting Started' heading"). onChat(mode) opens Chat in that mode.
// The gradients are as they were on Today; they are debt to move into tokens.
const GREEN = "linear-gradient(135deg, #1A7A48, #3DAA6A)";
const BUTTONS = [
  { mode: "plan", label: "Plan My Day", bg: GREEN },
  { mode: "motivate", label: "Motivate Me", bg: "linear-gradient(135deg, #B52040, #E8556A)" },
  { mode: "checkin", label: "Check In", bg: GREEN },
];

export function NeedANudge({ onChat }) {
  return (
    <section aria-labelledby="need-a-nudge" style={{ background: C.foldCard, borderRadius: C.r, border: `1px solid ${C.borderCard}`, padding: "14px 16px", boxShadow: C.shadow }}>
      <h3 id="need-a-nudge" style={{ margin: "0 0 10px", fontSize: 12, fontWeight: 700, color: C.textGreen, letterSpacing: "0.07em", textTransform: "uppercase" }}>Need a nudge?</h3>
      <div style={{ display: "flex", gap: 10 }}>
        {BUTTONS.map(b => (
          <button key={b.mode} onClick={() => onChat(b.mode)}
            style={{ flex: 1, minHeight: 44, background: b.bg, color: C.onTier, border: "none", borderRadius: C.rsm, padding: "11px 8px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", lineHeight: 1.3 }}>
            {b.label}
          </button>
        ))}
      </div>
    </section>
  );
}
